var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClothes3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 159,
    viewBox: "0 0 150 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1 1.79999C34.7 1.79999 42.3 10 41.7 19.6L34.6 96.3L3 91.5C3.5 86 6.8 48.5 8.3 17.7C8.7 8.8 16.1 1.69999 25.1 1.79999Z",
    fill: "#FE667A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7 97.3L0 92.6L1.6 80.3L37.8 85.4L36.7 97.3Z",
    fill: "#FF8A9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.5 17.7C142.9 48.5 146.3 86 146.7 91.5L115.1 96.3L108 19.6C107.4 10 115 1.79999 124.7 1.79999C133.6 1.69999 141 8.8 141.5 17.7Z",
    fill: "#FE667A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.9 85.4L148.2 80.3L149.7 92.6L113 97.3L111.9 85.4Z",
    fill: "#FF8A9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.6 1.9L120.4 158.4H74.1998H27.9998L22.7998 1.9L49 0H59L74.5 6L91 0H99.5L125.6 1.9Z",
    fill: "#FE667A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9002 95.5999L23.7002 30.2",
    stroke: "#E2425D",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.5 95.5999L124.7 30.2",
    stroke: "#E2425D",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothes3);
export default __webpack_public_path__ + "static/media/clothes-3.850ae3edb9356ffc268ee33f125a283b.svg";
export { ForwardRef as ReactComponent };